/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import type * as d3 from 'd3';
import type { MutableRefObject } from 'react';
import type { Margin } from './drawUtils';

export const animateResizeTransform = (
  svg: d3.Selection<SVGElement, unknown, HTMLElement, unknown>,
  marginLocal: Margin,
  innerHeight: number,
  prevInnerHeightRef: MutableRefObject<number | null>,
): void => {
  const prevInnerHeight =
    typeof prevInnerHeightRef.current === 'number'
      ? prevInnerHeightRef.current
      : 0;

  const scaleYStart =
    prevInnerHeight > 0 && innerHeight > 0 ? prevInnerHeight / innerHeight : 0;

  svg
    .attr(
      'transform',
      `translate(${marginLocal.left},${marginLocal.top}) scale(1,${scaleYStart})`,
    )
    .transition()
    .duration(300)
    .attr(
      'transform',
      `translate(${marginLocal.left},${marginLocal.top}) scale(1,1)`,
    );
};
